/**
 * Explicit allow-list of in-app destinations a `redirect` query param may point
 * to. Adding a new destination is a security-review change, not a convenience
 * one — this is the open-redirect boundary.
 *
 * Shared deliberately: /autologin receives the param from the mobile handoff,
 * and PublicRoute has to hand a user back to it after a login. Two copies of an
 * allow-list drift, and a drifted allow-list is an open redirect.
 */
const ALLOWED_REDIRECTS: ReadonlyArray<RegExp> = [
  /^\/membership-info\/?$/,
  // /unsubscribe-feedback/:subscriptionId
  /^\/unsubscribe-feedback\/[A-Za-z0-9_-]{1,64}\/?$/,
]

export const DEFAULT_DESTINATION = '/onboarding'

export function isAllowedRedirect(path: string | null): path is string {
  if (!path) return false
  if (path.length > 256) return false
  return ALLOWED_REDIRECTS.some((rx) => rx.test(path))
}

/** The requested destination when it passes the allow-list, else the default. */
export function safeRedirect(path: string | null): string {
  return isAllowedRedirect(path) ? path : DEFAULT_DESTINATION
}
